import { Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Golf } from '@aps-management/primapp-common';

import { parseLinks } from '_components/helpers/parseLinks';
import masterClient from '_utils/masterClient';

const styles = (theme) => ({
  root: {
    padding: theme.spacing.unit * 2,
    margin: `${theme.spacing.unit * 2}px 0`,
    borderRadius: 8,
    backgroundColor: 'transparent',
  },
  text: {
    whiteSpace: 'pre-line', // respecte les sauts de ligne
    lineHeight: 1.5,
  },
});

const Notice = ({ app, classes, context, lang = 'FR', PaperProps = {}, TypographyProps = {} }) => {
  const { golf } = app;
  const [content, setContent] = useState('');

  useEffect(() => {
    Golf.api.getNotices(masterClient, { id: golf.id }, 'cache-first').then((notices) => {
      const notice = notices.find((n) => n.context === context && n.lang === lang);
      setContent(notice?.content || '');
    });
  }, [golf.id, context, lang]);

  if (!content) return null;

  return (
    <Paper {...PaperProps} className={classNames(classes.root, PaperProps.className)}>
      <Typography variant='body2' {...TypographyProps} className={classNames(classes.text, TypographyProps.className)}>
        {parseLinks(content, { markdown: true })}
      </Typography>
    </Paper>
  );
};

const mapStateToProps = ({ app }) => ({ app });

export default connect(mapStateToProps, null)(withStyles(styles)(Notice));
